const stdInfoRoutes = [
  {
    path: "/std-info",
    name: "",
    meta: {
      title: "비교과",
      isDynamic: true,
    },
    children: [
      {
        path: "index",
        name: "stdInfoIndex",
        meta: {
          title: "학생 정보 조회",
          titleEn: "Student Information Inquiry",
          menuCd: "STAFF_STUDENT_INFO",
          isDynamic: true,
        },
        component: () => import("@/views/staff/stdInfo/StaffStdInfoIndex.vue"),
      },
      {
        path: "shreg/:id",
        name: "stdInfoShreg",
        meta: {
          title: "학적 정보 조회",
          titleEn: "Student Academic Information Inquiry",
          menuCd: "STAFF_STUDENT_INFO",
          isDynamic: true,
        },
        component: () => import("@/views/staff/stdInfo/shreg/StaffStdShregIndex.vue"),
      },
    ],
  },
];

export default stdInfoRoutes;
